interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Avalanche = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_26599)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#E84142"
      />
      <path
        d="M59.7913 45.316L44.3251 72.5832C42.9715 74.9642 40.4447 76.4428 37.7027 76.4428H22.4031C20.5635 76.4428 19.4112 74.4575 20.3136 72.8609L47.9071 24.2131C48.8234 22.5956 51.1627 22.5956 52.0791 24.2131L59.7913 37.805C61.1103 40.1374 61.1103 42.9905 59.7913 45.316Z"
        fill="white"
      />
      <path
        d="M65.8237 55.798L56.1469 72.8609C55.2376 74.4575 56.3968 76.4428 58.2364 76.4428H77.5969C79.4365 76.4428 80.5888 74.4575 79.6864 72.8609L70.0096 55.798C69.0933 54.1806 66.7539 54.1806 65.8376 55.798H65.8237Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_188_26599">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
